import { ChevronDoubleLeftIcon, ChevronDoubleRightIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon, SelectorIcon } from "@heroicons/react/outline"
import { useGlobalFilter, usePagination, useSortBy } from "react-table/dist/react-table.development"

const {useTable} = require("react-table")

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export const TableUi = ({columns, data, colsHidden, showSearch = true, showPagination = true}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // rows, // for the pagination use page instead
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable({
    columns, 
    data,
    initialState:{hiddenColumns:colsHidden}
    }, 
    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const {globalFilter, pageIndex, pageSize} = state

  return (
    <div className="relative overflow-x-auto bg-white my-6">
      {showSearch && <TableSearch filter={globalFilter} setFilter={setGlobalFilter}/>}

      <table {...getTableProps()} className="min-w-max w-full table-auto">
        <thead>
          {
            headerGroups.map((hg) => (
              <tr {...hg.getHeaderGroupProps()} className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
                {
                  hg.headers.map((col) => {
                    return (
                      <th {...col.getHeaderProps(col.getSortByToggleProps())} className="py-3 px-6">
                        <div className="flex items-center justify-center gap-2">
                          {col.render('Header')}
                          <span>
                            {
                            col.Header !== 'Image' && col.Header !== 'Action' && (
                              col.isSorted ? (
                                col.isSortedDesc 
                                ? <ChevronDownIcon className="h-3 w-3 text-gray-700" />
                                : <ChevronUpIcon className="h-3 w-3 text-gray-700" />
                              ) : <SelectorIcon className="h-4 w-4 text-gray-700" />
                            )
                            }
                          </span>
                        </div>
                      </th>
                    )
                  }
                  )
                }
              </tr>
            ))
          }
        </thead>

        <tbody {...getTableBodyProps()} className="text-gray-600 text-sm font-light">
          {
            page.map((row) => {
              prepareRow(row)
              return (
                <tr {...row.getRowProps()} className="border-b border-gray-200 hover:bg-gray-100">
                  {row.cells.map((cell) => {
                    return <td {...cell.getCellProps()} className="py-2 px-6 text-center">{cell.render('Cell')}</td>
                  })}
                </tr>
              )
            })
          }
        </tbody>
      </table>

      {
        showPagination && <div className="pl-2 py-3 flex gap-2">
          <div className="py-3">
            Page{' '}
            <strong>
              {pageIndex + 1} / {pageOptions.length}
            </strong>{' '}
          </div>
          <select className="mt-1 h-10 cursor-pointer rounded-full focus:outline-none border-none" value={pageSize} onChange={(e) => setPageSize(e.target.value)}>
            {
              [5, 10, 25, 50].map(pageSize => (
                <option value={pageSize} key={pageSize}>Show {pageSize}</option>
              ))
            }
          </select>
         
          <button className={classNames(
            canPreviousPage ? '' : ' opacity-70',
            'h-8 w-8 flex items-center justify-center mt-2 text-white rounded-full bg-primary'
          )} onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
            <ChevronDoubleLeftIcon className='content-center flex-shrink-0 h-5 w-5' aria-hidden="true"/>
          </button>
          <button className={classNames(
            canPreviousPage ? '' : ' opacity-70',
            'h-8 w-8 flex items-center justify-center mt-2 text-white rounded-full bg-primary'
          )} onClick={() => previousPage()} disabled={!canPreviousPage}>
            <ChevronLeftIcon className='content-center flex-shrink-0 h-5 w-5' aria-hidden="true"/>
          </button>
          <button className={classNames(
            canNextPage ? '' : ' opacity-70',
            'h-8 w-8 flex items-center justify-center mt-2 text-white rounded-full bg-primary'
          )} onClick={() => nextPage()} disabled={!canNextPage}>
            <ChevronRightIcon className='content-center flex-shrink-0 h-5 w-5' aria-hidden="true"/>
          </button>
          <button className={classNames(
            canNextPage ? '' : ' opacity-70',
            'h-8 w-8 flex items-center justify-center mt-2 text-white rounded-full bg-primary'
          )} onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
            <ChevronDoubleRightIcon className='content-center flex-shrink-0 h-5 w-5' aria-hidden="true"/>
          </button>
        </div>
      }
    </div>
  )
}




const TableSearch = ({filter, setFilter}) => {
  return (
    <div className="py-2">
      <span>
        Recherche: {' '}
        <input className="h-7 w-auto rounded-full focus:outline-none border-0 bg-gray-100" placeholder="recherche..." type="text" value={filter || ''} onChange={(e) => setFilter(e.target.value)} />
      </span>
    </div>
  )
}